import { render, staticRenderFns } from "./BzForm.vue?vue&type=template&id=30f890eb&"
import script from "./BzForm.vue?vue&type=script&lang=js&"
export * from "./BzForm.vue?vue&type=script&lang=js&"
import style0 from "./BzForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BzForm.vue"
export default component.exports